import React from 'react';
import { IFormatterProps } from '../../../@types/workspaceTypes';
import { ICustomerPartNumber, ICustomerSpecialPrice } from '../../../graphql/schema/p4types';

const PartNumberFormatter = (props: IFormatterProps<ICustomerSpecialPrice, string | null>) => {
  const { product, customer } = props.dependentValues.rowData;
  // if prop customer id is the same as the provided customer id, return true
  const sameCustomer = (cpn: ICustomerPartNumber) => cpn.customer?.id === customer?.id;
  const customerPartNumbers = product?.customerPartNumbers?.find(sameCustomer);

  let value = '';
  if (customerPartNumbers?.partNumber) {
    value = customerPartNumbers.partNumber;
  }
  return <div>{value}</div>;
};

export default PartNumberFormatter;
